module.exports = __webpack_public_path__ + "fonts/iconfont.213b3e62.ttf";